import React from 'react';
import { Control, useWatch } from 'react-hook-form';
import { Button } from '@mui/material';
import TextInputCell from './TextInputCell';
import { Inputs } from '../admin-kategorije/AddKvizPitanjeModal';
import { Delete } from '@mui/icons-material';
import '../../../style/SimpleTable.css';

interface RiskTableInterface {
    control: Control<Inputs> | undefined;
    fields: any[];
    remove: any;
    errors?: any;
}

function ConnectTable({ control, fields, remove, errors }: RiskTableInterface) {
    return (
        <table className="simple-table mt-[10px] gap-[6px]">
            <thead>
                <tr className="simple-table-header">
                    <th className=" w-[30px] h-[54px]">Broj</th>
                    <th className=" w-[450px] h-[54px]">Prvi član</th>

                    <th className=" w-[450px] h-[54px]">Drugi član</th>

                    <td className={` invisible`} style={{ border: 0 }}>
                        {/* <div className="w-fit cursor-pointer">
                        <Edit />
                        </div> */}

                        <Button className="w-fit cursor-pointer p-0" disabled={true}>
                            <Delete />
                        </Button>
                    </td>
                </tr>
            </thead>
            <tbody>
                {fields.map((field, index) => (
                    <tr className="simple-table-row" key={field.id}>
                        <td className=" disabled w-[30px] " style={{ textAlign: 'center' }}>
                            {index + 1}
                        </td>
                        <td className=" editable w-[450px] " style={{ padding: 0, border: 0 }}>
                            <TextInputCell
                                name={`connections.${index}.firstItem`}
                                control={control}
                                placeholder="Prvi član"
                                errors={errors}
                                isRequired={true}
                            />
                        </td>

                        <td className=" editable w-[450px] " style={{ padding: 0, border: 0 }}>
                            <TextInputCell
                                name={`connections.${index}.secondItem`}
                                control={control}
                                placeholder="Drugi član"
                                errors={errors}
                                isRequired={true}
                            />
                        </td>
                        <td className={`  ${fields.length > 1 ? 'visible' : 'invisible'}`} style={{ border: 0, padding: 0 }}>
                            <Button style={{ padding: 0, maxWidth: 24 }} onClick={() => remove(index)}>
                                <Delete color={'error'} />
                            </Button>
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
}

export default ConnectTable;
